/**
 * AspectAttachmentContent — renders BOTH `aspect_attached` and `aspect_detached`.
 *
 * One component for the pair, matching how PerspectiveAssignedContent already handles
 * assigned/unassigned: the payload is identical and only the direction differs, so two components
 * would duplicate everything except a single i18n key.
 */
import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface Props {
  event: TimelineEvent;
}

const AspectAttachmentContent: React.FC<Props> = ({ event }) => {
  const { t } = useTranslation();
  const payload = (event.payload ?? {}) as { aspectSystemName?: string };
  const attached = event.eventType === 'aspect_attached';

  return (
    <div className="timeline-event-content">
      <span className="timeline-event-content__text">
        {t(attached ? 'timeline.eventContent.aspectAttached' : 'timeline.eventContent.aspectDetached', {
          aspect: payload.aspectSystemName ?? '',
        })}
      </span>
    </div>
  );
};

export default AspectAttachmentContent;
